import type { IconName } from '../chrome/Icon';
import type { ActivityCategory } from '../../data/dto';

/** Icon, label and accent colour for each activity category. */
export const ACTIVITY_CATEGORY_META: Record<
  ActivityCategory,
  { icon: IconName; label: string; color: string }
> = {
  play:      { icon: 'play',    label: 'Play',      color: '#D98E5A' },
  sing:      { icon: 'sing',    label: 'Sing',      color: '#A579B0' },
  music:     { icon: 'music',   label: 'Music',     color: '#A579B0' },
  read:      { icon: 'read',    label: 'Read',      color: '#6F9E6E' },
  excursion: { icon: 'explore', label: 'Adventure', color: '#5E92B0' },
};

export const ACTIVITY_CATEGORIES: ActivityCategory[] = ['play', 'sing', 'music', 'read', 'excursion'];

/** Friendly label for a subcategory key (e.g. nursery_rhyme → "Nursery rhyme"). */
export function subcategoryLabel(sub: string | null): string | null {
  if (!sub) return null;
  const SPECIAL: Record<string, string> = {
    nursery_rhyme: 'Nursery rhyme',
    classical:     'Listen · Classical',
    era:           'Listen · Eras',
    relax:         'Relax',
    party:         'Party',
  };
  return SPECIAL[sub] ?? sub.replace(/_/g, ' ');
}
